<template>
    <tr class="itemLista hover">
        <td>{{rubricas.codigo}}</td>
        <td>{{rubricas.nome}}</td>
        <td>{{rubricas.descricao}}</td>
        <td class="tdBotao"><button class="btn btn-info" @click="buscar()">Selecionar</button></td>
    </tr>    
</template>
<script>
export default {
    data(){
        return{
            dados: this.rubricas.codigo
        }
    },
    props: ["rubricas"],
    methods:{
        buscar(){
            this.$emit('codigoSelecionado',{
                    codigo: this.dados
            });
        }
    }
}
</script>
<style scoped>
    .tdBotao{
        width: 6em;
        vertical-align: middle; 
    }
    .itemLista{
        font-size: 90%;
    }
    .hover:hover{
        background-color: lightgrey;
    }
</style>





// WEBPACK FOOTER //
// src/components/rubricas-all.vue